import React from "react";
import { Bars } from "react-loader-spinner"; //MIGRATION: Had to swap libraries because the better-react-spinkit was not supported by the newest react. Happy to change to whatever
import cn from "classnames";

import "./Spinner.scss";

export const Spinner = React.memo<{
  size?: number;
  color?: string;
}>((props) => (
  <div className="BPMSpinner">
    <Bars {...props} />
  </div>
));

interface FullPageSpinnerProps {
  transparent?: boolean;
  fixed?: boolean;
}

export const FullPageSpinner: React.FC<FullPageSpinnerProps> = ({
  transparent,
  fixed,
}) => (
  <div className={cn("bpmFullPageSpinner", { transparent, fixed })}>
    <Spinner size={100} />
  </div>
);
